import React from 'react';
import { FileText, PhoneCall, Building2, Users } from 'lucide-react';

const NAV_ITEMS = [
  { value: 'kyc', label: 'KYC', icon: FileText, testId: 'admin-nav-kyc' },
  { value: 'users', label: 'Users', icon: Users, testId: 'admin-nav-users' },
  { value: 'requests', label: 'Requests', icon: PhoneCall, testId: 'admin-nav-requests' },
  { value: 'orgs', label: 'Orgs', icon: Building2, testId: 'admin-nav-orgs' },
];

export default function AdminBottomNav({ active, onChange }) {
  return (
    <div
      className="fixed bottom-3 left-1/2 -translate-x-1/2 w-[calc(100%-24px)] max-w-[420px] md:max-w-[520px] lg:max-w-[560px] bg-white/85 backdrop-blur-2xl border border-[#E4E8EF] rounded-full shadow-[0_16px_40px_-16px_rgba(11,22,32,0.18),0_2px_6px_-2px_rgba(11,22,32,0.06)] pb-[env(safe-area-inset-bottom)] px-2 py-1.5 flex justify-around items-center z-[9999]"
      data-testid="admin-bottom-nav"
    >
      {NAV_ITEMS.map((item) => {
        const isActive = active === item.value;
        const Icon = item.icon;
        return (
          <button
            key={item.value}
            data-testid={item.testId}
            onClick={() => onChange(item.value)}
            className={`relative flex flex-col items-center gap-0.5 py-1.5 px-1 rounded-full transition-all duration-200 flex-1 min-w-0 ${
              isActive ? 'text-[#0B4F3F]' : 'text-[#5B6675] hover:text-[#0B1620]'
            }`}
          >
            <Icon className="w-[18px] h-[18px]" strokeWidth={isActive ? 2.4 : 1.6} />
            <span className={`text-[9px] truncate ${isActive ? 'font-semibold' : 'font-medium'}`}>{item.label}</span>
            {isActive && (
              <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#0B4F3F] shadow-[0_0_6px_rgba(11,79,63,0.6)]" />
            )}
          </button>
        );
      })}
    </div>
  );
}
